/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RootStoreType } from "./index"


/**
 * SessionCheckoutDtoBase
 * auto generated base class for the model SessionCheckoutDtoModel.
 */
export const SessionCheckoutDtoModelBase = ModelBase
  .named('SessionCheckoutDto')
  .props({
    __typename: types.optional(types.literal("SessionCheckoutDto"), "SessionCheckoutDto"),
    clientSecret: types.union(types.undefined, types.string),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class SessionCheckoutDtoModelSelector extends QueryBuilder {
  get clientSecret() { return this.__attr(`clientSecret`) }
}
export function selectFromSessionCheckoutDto() {
  return new SessionCheckoutDtoModelSelector()
}

export const sessionCheckoutDtoModelPrimitives = selectFromSessionCheckoutDto().clientSecret
